import {
  AfterCreateLevelChangeOutDto,
  LevelCreateOutDto,
  LevelEditOutDto,
} from 'shared/dtos/out/level';
import { LevelCreateModel, LevelEditModel } from '../types/model';

export function levelCreateModelToOutDto(
  model: LevelCreateModel
): LevelCreateOutDto {
  return {
    label: model.label,
    site: model.site,
    index: 0,
  };
}

export function levelCreateModelToChangeOutDto(
  model: LevelCreateModel
): AfterCreateLevelChangeOutDto | undefined {
  return model.map ? { map: model.map.documentationId } : undefined;
}

export function levelEditModelToOutDto(
  levelEditModel: LevelEditModel
): LevelEditOutDto {
  const { _id, label, map } = levelEditModel;
  return {
    levelId: _id,
    ...(label ? { label } : {}),
    ...(map !== undefined ? { map: map?.documentationId ?? null } : {}),
  };
}
